import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';

interface SiteConfig {
    activeTone: string;
    setActiveTone: (tone: string) => void;
}

const SiteConfigContext = createContext<SiteConfig | undefined>(undefined);

export const useSiteConfig = () => {
    const context = useContext(SiteConfigContext);
    if (context === undefined) {
        throw new Error('useSiteConfig must be used within a SiteConfigProvider');
    }
    return context;
};

interface SiteConfigProviderProps {
    children: ReactNode;
}

const SiteConfigProvider: React.FC<SiteConfigProviderProps> = ({ children }) => {
    const [activeTone, setActiveTone] = useState('author-tone');

    useEffect(() => {
        fetch('/tone.json')
            .then((res) => res.json())
            .then((data: { activeTone?: string }) => {
                if (data.activeTone) setActiveTone(data.activeTone);
            })
            .catch(() => {});
    }, []);

    return (
        <SiteConfigContext.Provider value={{ activeTone, setActiveTone }}>
            {children}
        </SiteConfigContext.Provider>
    );
};

export default SiteConfigProvider;
